import { supabase } from '../integrations/supabase/client.js';
import { StateHistoryTriggerSource } from '../types/stateHistory.js';

/**
 * Records a state change to the state_history table.
 * This is a standalone function with NO React dependencies, 
 * making it safe for both frontend and backend use.
 */
export async function recordStateChange(params: {
  teamId: string;
  tagId: string;
  fromStateId: string | null;
  toStateId: string;
  triggerSource: StateHistoryTriggerSource;
  changedByMemberId?: string | null;
  changedByDeviceId?: string | null;
  triggerReference?: string | null;
}) {
  const { error } = await (supabase
    .from('state_history' as any)
    .insert({
      team_id: params.teamId,
      tag_id: params.tagId,
      from_state_id: params.fromStateId,
      to_state_id: params.toStateId,
      trigger_source: params.triggerSource,
      changed_by_member_id: params.changedByMemberId || null,
      changed_by_device_id: params.changedByDeviceId || null,
      trigger_reference: params.triggerReference || null,
    }) as any);

  if (error) {
    console.error('Error recording state history:', error);
  }
}
